// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3RqSa","calendarButtons":"ClockData_calendarButtons__2twAm"};